export default {
  common: {
    casino: "Casino",
    more: "Higit pa",
    searchGames: "Maghanap ng laro",
    copied: "Nakopya na!",
    inputTooLong: "Masyadong mahaba ang input, mangyaring mag-input muli.",
    inputNameCn: "Mga Chinese na karakter, letra, numero at underscore lamang ang pinapayagan",
    inputCapital: "Malalaking letra at underscore lamang ang pinapayagan",
    inputLowercaseUnderscore: "Maliliit na letra at underscore lamang ang pinapayagan",
    inputLowercase: "Maliliit na letra lamang ang pinapayagan",
    inputNoSpace: "Mangyaring huwag mag-input ng puro espasyo lamang",
    inputValidPhone: "Mangyaring maglagay ng wastong numero ng telepono",
    inputNonNumber: "Naglalaman ng hindi-numerong karakter",
    inputNonLetter: "Naglalaman ng hindi-letrang karakter",
    inputLetterOrNumberOnly: "Mga letra o numero lamang ang pinapayagan",
    phoneFormatError: "Hindi wastong format ng numero ng telepono",
    inputLetterStartNumber: "Dapat magsimula sa letra at maaaring maglaman ng numero",
    inputNoChinese: "Hindi pinapayagan ang mga Chinese na karakter",
    inputChineseOnly: "Mga Chinese na karakter lamang ang pinapayagan",
    emailFormatError: "Hindi wastong format ng email",
    urlFormatError: "Hindi wastong format ng URL",
    jsonFormatError: "Hindi wastong format ng JSON",
    networkError: "Hindi maabot ang server, mangyaring subukan muli mamaya.",
    siteUnavailable: "Kasalukuyang hindi magamit ang site na ito, mangyaring makipag-ugnayan sa administrator.",
    tokenExpired: "Nag-expire na ang iyong session, mangyaring mag-sign in muli.",
    domainNotAuthorized: "Hindi awtorisado ang domain",
    demoEnvOnly: "Demo na kapaligiran, para sa preview lamang",
    passwordLength630: "6-30 na karakter",
    newPasswordSameAsOld: "Ang bagong password ay hindi maaaring pareho sa lumang password",
    confirmNewPassword: "Mangyaring kumpirmahin ang iyong bagong password",
    passwordsDoNotMatch: "Hindi magkatugma ang mga password",
    withdrawPasswordChanged: "Matagumpay na nabago ang password sa withdraw",
    withdrawPasswordSet: "Matagumpay na naitakda ang password sa withdraw",
    withdrawPasswordSetFailed: "Nabigong itakda ang password sa withdraw",
    phoneDigitsOnly: "Ang numero ng telepono ay dapat mga digit lamang",
    phoneTooShort: "Masyadong maikli ang numero ng telepono (min {min} na digit)",
    phoneTooLong: "Masyadong mahaba ang numero ng telepono (max {max} na digit)",
    phoneInvalidPrefix: "Hindi wastong prefix ng numero ng telepono",
    rolloverAll: "Lahat ng uri",
    rolloverAllStats: "Lahat ng Status",
    rolloverSuccessful: "Matagumpay",
    rolloverFailed: "Nabigo",
    rolloverInProgress: "Isinasagawa",
    rolloverSuccess: "Tagumpay",
    rolloverPending: "Nakabinbin",
    rolloverCompleted: "Nakumpleto",
    rolloverCancelled: "Kinansela",
    rolloverExpired: "Nag-expire",
    walletCash: "Cash",
    walletBonus: "Bonus",
    sourceDeposit: "Deposit",
    sourceCommission: "Komisyon",
    sourceManualAdd: "Manual na Pagdagdag",
    sourceManualSubtract: "Manual na Pagbawas",
  },
  redeemCode: {
    enterTip: "Ilagay ang iyong redeem code para makuha ang mga gantimpala",
    placeholder: "Mangyaring ilagay ang iyong code",
    redeemBtn: "I-REDEEM",
    pleaseEnterCode: "Mangyaring ilagay ang iyong redeem code",
    redeemSuccess: "Matagumpay ang pag-redeem!",
    redeemFailed: "Nabigo ang pag-redeem, subukan muli",
  },
}
